import { axiosInstance } from '@services/base-service';
import { getEnv } from '@config';

const loginUri = '/merchant/bff/login';
const { orgId } = getEnv();

export const sendResetPasswordEmail = async ({ email }, callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .post(
        `${loginUri}/merchant/change-password`,
        { payload: { email } },
        { hasAuthorization: false }
      )
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const resetPassword = async ({ token, password }, callbackSuccess, callbackError) => {
  try {
    await axiosInstance
      .getInstance()
      .post(
        `${loginUri}/merchant/reset/${token}`,
        { payload: { password } },
        { hasAuthorization: false }
      )
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError(error);
  }
};

export const validateTokenResetPassword = ({ token }, callbackSuccess, callbackError) => {
  try {
    axiosInstance
      .getInstance()
      .post(`${loginUri}/merchant/reset/validate/${token}`, {}, { hasAuthorization: false })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const login = ({ email, password, sessionId }, callbackSuccess, callbackError) => {
  try {
    axiosInstance
      .getInstance()
      .post(
        `${loginUri}/merchant`,
        { payload: { email, password, org_id: orgId, session_id: sessionId } },
        { hasAuthorization: false }
      )
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const logout = ({ fingerprint }, callbackSuccess, callbackError) => {
  try {
    axiosInstance
      .getInstance()
      .delete(`${loginUri}/merchant/session/${fingerprint}`, {
        headers: {
          'x-flow-service': 'MERCHANT',
        },
      })
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const tyc = ({ merchantId, version }, callbackSuccess, callbackError) => {
  try {
    axiosInstance
      .getInstance()
      .post(
        `${loginUri}/merchant/tyc/${merchantId}`,
        {
          payload: {
            tyc: {
              id: 'MERCHANT',
              accepted: true,
              version,
            },
          },
        },
        { hasAuthorization: false }
      )
      .then(
        (response) => callbackSuccess(response),
        (error) => callbackError(error)
      );
  } catch (error) {
    callbackError({ message: 'Error de conexion' });
  }
};

export const fetchUsersByRut = async (rut) =>
  axiosInstance
    .getInstance()
    .post(`${loginUri}/merchant/forgot/user`, { payload: { document: rut } });
